<template>
    <div class="body d-flex py-lg-3 py-md-2">
        <div class="container-xxl">
            <div class="row clearfix">
                <div class="col-md-12">
                    <div class="card border-0 mb-1 no-bg">
                        <div
    class="card-header py-1 px-0 d-flex align-items-center justify-content-between main-button-area"
>
    <div class="header-section d-flex align-items-center w-100 justify-content-between">
                                <div class="search-area mt-1" style="flex: 0 0 240px">
            <input
                id="main-search-input"
                type="search"
                class="form-control"
                placeholder="Αναζήτηση..."
                aria-label="search"
                aria-describedby="addon-wrapping"
            />
        </div>
                             <!-- Title -->
                             <h3 class="flex-grow-1 m-0 my-2 ms-3 wx-list-title">
    {{ title }}
</h3>

<!-- Επεξεργασία επαφών button -->
<router-link
  :to="`/edit-list?id=${listId}`"
    class="btn wx-icon-btn ms-2"
>
    <i class="wx-ic wx-ic-edit"></i> Επεξεργασία επαφών
</router-link>

   
                            </div>
                            
                          
                        </div>
                    </div>
                </div>
            </div>
            <div class="row clearfix g-1">
                <div class="col-lg-12">
                    <div>
                        <div class="card-body table-responsive">
                            <TableViewList 
                            :columns="columns" 
                            :data="data" 
                            :applyFilters="applyFilters"
                            :paginationLinks="paginationLinks" 
                            :archiveContacts="archiveContacts" 
                            :tableOptions="tableOptions" 
                            :isLinkColumn="isLinkColumn" 
                            :sortBy="sortBy" 
                            :refreshTable="fetchData"
                            :count="count"
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="modal fade" id="create-list-form" tabindex="-1" aria-labelledby="createprojectlLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="createprojectlLabel">Στοιχεία λίστας</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="title" class="form-label">Title</label>
                            <input type="text" class="form-control" id="title" v-model="listData.title"
                                placeholder="Title">
                        </div>

                    </div>
                    <div class="modal-footer">
                        <!--                         <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Κλείσιμο</button>
 --> <button type="button" class="btn btn-secondary" @click="submitForm">Αποθήκευση</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useFetchData } from '@/composables/useFetchDataListContacts';
import { fetchAll } from '@/services/list-contacts';
import { get } from '@/services/lists';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';
import TableViewList from '@/components/TableViewList.vue';
import { create } from '@/services/lists';

const defaultListData = {
    title: ''
};

export default {
    name: 'List',
    components: {
        Editor,
        Select2,
        TableViewList
    },
    methods: {

        canEditContact(contact) {
            if (!contact) { return false; }
            return localStorage.getItem('current_user_id') == contact?.createdBy && this.userPermissions?.edit === 1;
        },


    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission', // Add this line

        }),


        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Contacts');
        },

        canEditAllContacts() {
            return this.userPermissions?.editAll === 1;
        },
        canCreateContact() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
    },
    setup() {
        const allData = ref({});

        const route = useRoute();
        const router = useRouter();

  const listId = computed(() => route.query.id); 

        const { title, data, count, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(get, { page: route.query.page || 1, search: route.query.search || null}, {search: null, page: 1});
    
        const listData = ref(defaultListData);
        const selectedClientIds = ref([]);
        const tableOptions = {path: 'list-profile', singlePagePath: 'contact'};

        const columns = ref([
            { value: "name", label: "Name"},
            { value: "clientNickname", label: "Client Nickname"},
            { value: "supplierNickname", label: "Supplier Nickname"},
            { value: "phone", label: "TELEPHONE" },
            { value: "email", label: "EMAIL" },
            { value: "address", label: "ADDRESS" },
            { value: "postal", label: "POSTAL CODE" },
            { value: "afm", label: "AFM" },
        ]);

        const applyFilters = (filters) => {
            updateFilters(filters.value);
        };

        const isDropdownOpen = ref(false);

        const toggleClientSelection = (clientId, event) => {
            if (!selectedClientIds.value.includes(clientId)) {
                selectedClientIds.value.push(clientId);
            } else {
                selectedClientIds.value = selectedClientIds.value.filter(id => id !== clientId);
            }
        };

        const toggleSelectAll = (event) => {
            if (Array.isArray(data.value)) { // Ensure `data.value` is an array
                if (event.target.checked) {
                    selectedClientIds.value = data.value.map(contact => contact.id); // Select all contact IDs
                } else {
                    selectedClientIds.value = []; // Clear all selections
                }
            } else {
                console.error('Expected data to be an array but got:', typeof data.value);
            }
        };



        const isAllSelected = computed(() => {
            return data.length > 0 && selectedClientIds.value.length === data.length;
        });


        const archiveContacts = async (selectedClientIds) => {
            if (!selectedClientIds.length) {
                useToast().error('Δεν έχετε επιλέξει επαφές');
                return;
            }
            const response = await massArchiveContacts({ ids: selectedClientIds });
            if (response.data.success) {
                useToast().success(response.data.message);
                fetchData();
            } else {
                useToast().error(response.data.message);
            }
        };

        const editList = async (id) => {
            const tmpAllData = await getClientsServicesStatusesUsers();

            let newData = { clients: [], suppliers: [] };


            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.suppliers.length; i++) {
                newData.suppliers.push({ id: tmpAllData.data.suppliers[i].id, text: tmpAllData.data.suppliers[i].title });
            }
            allData.value = newData;

            const clientInfo = await get({ "id": id });
            if (clientInfo.data.success) {
                contactData.value.id = clientInfo.data.data.id;
                contactData.value.name = clientInfo.data.data.name;
                contactData.value.description = clientInfo.data.data.description;
                contactData.value.email = clientInfo.data.data.email;
                contactData.value.phone = clientInfo.data.data.phone;
                contactData.value.address = clientInfo.data.data.address;
                contactData.value.postal = clientInfo.data.data.postal;
                contactData.value.occupation = clientInfo.data.data.occupation;
                contactData.value.afm = clientInfo.data.data.afm;
                contactData.value.clientId = clientInfo.data.data.clientId;
                contactData.value.supplierId = clientInfo.data.data.supplierId;
                contactData.value.notes = clientInfo.data.data.notes;
                contactData.value.paid = clientInfo.data.data.paid;
            }
            $("#create-list-form").modal('toggle');
        };

        const createClient = async () => {
            listData.value = {
                title: ''
            };
            $("#create-list-form").modal('toggle');
        };

        const submitForm = async () => {
            let finalListData = listData;
            finalListData.value.filter_data = filters.value;
            const response = await create(finalListData.value);
            if (response.data.success) {
                useToast().success(response.data.message);
                $("#create-list-form").modal('toggle');
                fetchData();
            } else {
                useToast().error('An error occurred');
            }
        };

        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const closeMenu = (event) => {
            if (document.querySelector('.dropdown-menu').length && !document.querySelector('.dropdown-menu').contains(event.target) && !document.querySelector('.dropdown-menu-toggler').contains(event.target)) {
                isDropdownOpen.value = false;
            }
        };

        const dropdownStyle = computed(() => ({
            top: isDropdownOpen.value ? '100%' : 'initial',
            right: isDropdownOpen.value ? '0' : 'initial'
        }));

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
        };

        const closeDropdown = () => {
            isDropdownOpen.value = false;
        };

        const select2Settings = {
            dropdownParent: '#create-list-form .modal-content',
            placeholder: "Please select"
        };

        const searchAction = () => {
            setTimeout(() => {
                router.push({ path: '/list-profile', query: { ...route.query, search: $("#main-search-input").val(), page: 1 } });
            }, 300);
        };

        onMounted(() => {
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
            document.addEventListener('click', closeMenu);
        });

        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
            document.removeEventListener('click', closeMenu);
        });

        const isLinkColumn = (value) => {
            return value == 'name' ? true : false;
        };

        return {
            title, applyFilters, count, isLinkColumn, tableOptions, columns, data, allData, paginationLinks, filters, updateFilters, fetchData, getPageFromUrl, listData, submitForm, editList, createClient, selectedClientIds, toggleClientSelection, archiveContacts, dropdownStyle, closeDropdown, isDropdownOpen, toggleDropdown, select2Settings, sortBy, toggleSelectAll, isAllSelected, listId
        };
    },
    metaInfo: {
        title: 'Επαφές',
        meta: [
            { name: 'description', content: 'MIS - Clients' },
            { property: 'og:title', content: 'MIS - Clients' },
            { property: 'og:description', content: 'This is the clients page.' }
        ]
    }
};
</script>

<style scoped>
.dropdown-menu.show {
    display: block;
}

tr.selected,
div.selected {
    background: #b1afaf;
}
</style>
